import { forwardRef } from 'react';
import clsx from 'clsx';
import { Loader2 } from 'lucide-react';

// Spec §4 — buttons: 8px radius, weight 500, blue hover shadow on primary CTAs.
const VARIANTS = {
  primary:
    'bg-brand-600 text-white hover:bg-brand-400 hover:shadow-[0_4px_12px_rgba(0,97,254,0.3)] active:bg-brand-700',
  secondary:
    'bg-slate-50 text-slate-800 border border-slate-200 hover:bg-slate-100 hover:border-slate-300 active:bg-slate-100',
  danger: 'bg-red-500 text-white hover:bg-red-600 active:bg-red-700',
  ghost:
    'bg-transparent text-slate-800 hover:bg-slate-100 active:bg-slate-200',
};

const SIZES = {
  sm: 'h-9 px-3.5 text-sm',
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-base',
};

const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', loading = false, disabled, className, children, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-all',
        'focus:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-60 disabled:shadow-none',
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...props}
    >
      {loading && <Loader2 className="h-4 w-4 animate-spin" aria-hidden />}
      {children}
    </button>
  );
});

export default Button;
